class VideoModal extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()
    if (!this.els?.video?.exists) return

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    if (this.externalEls?.trigger?.exists) {
      this.externalEls.trigger.elements.forEach(triggerEl => {
        this.listeners.add(triggerEl, `click`, this.handleTrigger)
      })
    }

    if (this.els?.close?.exists) {
      this.els.close.elements.forEach(close => {
        this.listeners.add(close, `click`, this.handleClose)
      })
    }
  }

  handleTrigger (event) {
    const videoModalKey = event.target.dataset?.videoModalKey
    if (videoModalKey !== this.videoModalKey) return

    this.isOpen = true

    if (!this.els.source.element.src) {
      this.els.source.element.src = this.els.source.element.dataset.src
      this.els.video.element.load()
    }
    this.els.video.element.play()
  }

  handleClose () {
    this.isOpen = false
    this.els.video.element.pause()
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (boolean) {
    this._isOpen = boolean

    this.setAttribute('aria-hidden', String(!boolean))
    this.hideWhenOpenEls?.forEach(hideWhenOpenEl => {
      hideWhenOpenEl.setAttribute('aria-hidden', String(boolean))
    })
  }

  get hideWhenOpenEls () {
    return this.externalEls?.['hide-when-open']?.elements.filter(
      hideWhenOpenEl =>
        hideWhenOpenEl.dataset?.videoModalKey === this.videoModalKey,
    )
  }

  get videoModalKey () {
    return this.dataset?.videoModalKey
  }
}

if (!customElements.get('video-modal')) {
  customElements.define('video-modal', VideoModal)
}
